import React, { useState, useEffect, useLayoutEffect } from "react";
import { useStyles } from "./LicensePlateSearchPage.styles";
import clsx from "clsx";
import AuthService from "../../services/AuthService";
import apiClient, { setAuthentication as setApiAuth } from "../../auth/apiClient";
import { setAuthenticationState } from "../../reducers/auth/authReducer";
import useAuthContext from "../../hooks/useAuthContext";
import { Grid, CircularProgress, Paper, Button, TextField } from "@material-ui/core";
import { useTheme } from "@material-ui/styles";
import GenericError from "../../components/MobilePayment/GenericError";
import { useParams } from "react-router-dom";
import LicensePlateSearchManagement from "../../components/LicensePlateSearchManagement/LicensePlateSearchManagement";

const LicensePlateSearchPage = () => {
    const authService = new AuthService(apiClient);
    const classes = useStyles();
    const theme = useTheme();
    const { entityID } = useParams();
    const { authReducer } = useAuthContext();
    const [, authDispatch] = authReducer;
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const getAuth = async () => {
        try {
            var appClientToken = await authService.getMobilePayAuthToken();
            if (appClientToken !== "") {
                setApiAuth(appClientToken);
                authDispatch({
                    type: setAuthenticationState,
                    payload: { properties: [] },
                });
                setIsAuthenticated(true);
            }
        } catch (error) {
            console.error("Error Authenticating", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (!isAuthenticated) {
            getAuth();
        }
    }, [authDispatch, isAuthenticated]);

    useLayoutEffect(() => {
        document.body.style.backgroundColor = theme.palette.background.level1;
    }, []);

    return (
        <div className={clsx(classes.root)}>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <img className={classes.logo} alt="company logo" src="/images/logos/a1-logo-stacked-dark.svg" />
                </Grid>
            </Grid>
            <div className={clsx(classes.contentContainer, "mobile-pay-landing-page-content")}>
                {isLoading === true ? (
                    <CircularProgress size={60} />
                ) : (
                    <>
                        {isAuthenticated ? (
                            <LicensePlateSearchManagement entityID={entityID}/>
                        ) : (
                            <GenericError message="Please try re-scanning with phone"></GenericError>
                        )
                        }
                    </>
                )}
            </div>
        </div>
    );
};
export default LicensePlateSearchPage;